import { BundleResourcesPackage } from "resource-system";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";
import { Object3D } from "three";
import { ThreeTexture } from "global";
import { Spritesheet } from "pixi.js";
import { Texture } from "@pixi/core";
export class GameResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("GameResourcesPackage");
    }
    public get assets_game_Boosters_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Boosters.glb");
    }
    public get assets_game_Box_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Box.glb");
    }
    public get assets_game_FarmerSimon_glb(): GLTF {
        return this.resource<GLTF>("assets/game/FarmerSimon.glb");
    }
    public get assets_game_Hat_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Hat.glb");
    }
    public get assets_game_Hole_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Hole.glb");
    }
    public get assets_game_IceCube_glb(): GLTF {
        return this.resource<GLTF>("assets/game/IceCube.glb");
    }
    public get assets_game_Level_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Level.glb");
    }
    public get assets_game_Mole_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Mole.glb");
    }
    public get assets_game_Mole_old_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Mole_old.glb");
    }
    public get assets_game_Parachute_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Parachute.glb");
    }
    public get assets_game_Tractor_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Tractor.glb");
    }
    public get assets_game_Turret_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Turret.glb");
    }
    public get assets_game_Vegetables_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Vegetables.glb");
    }
    public get assets_game_Weapons_glb(): GLTF {
        return this.resource<GLTF>("assets/game/Weapons.glb");
    }
    public get assets_game_particles_box_death_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/box_death.thjson");
    }
    public get assets_game_particles_box_landing_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/box_landing.thjson");
    }
    public get assets_game_particles_click_clods_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/click_clods.thjson");
    }
    public get assets_game_particles_explosion_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/explosion.thjson");
    }
    public get assets_game_particles_explosion_area_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/explosion_area.thjson");
    }
    public get assets_game_particles_freezing_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/freezing.thjson");
    }
    public get assets_game_particles_hole_clods_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/hole_clods.thjson");
    }
    public get assets_game_particles_lightning_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/lightning.thjson");
    }
    public get assets_game_particles_portal_clods_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/portal_clods.thjson");
    }
    public get assets_game_particles_sky_lightning_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/sky-lightning.thjson");
    }
    public get assets_game_particles_stunning_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/stunning.thjson");
    }
    public get assets_game_particles_tractor_earht_clods_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/tractor/earht_clods.thjson");
    }
    public get assets_game_particles_tractor_smoke_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/tractor/smoke.thjson");
    }
    public get assets_game_particles_tractor_trail_thjson(): Object3D {
        return this.resource<Object3D>("assets/game/particles/tractor/trail.thjson");
    }
    public get assets_game_particles_trail_cloud_thpng(): ThreeTexture {
        return this.resource<ThreeTexture>("assets/game/particles/trail/cloud.thpng");
    }
    public get assets_game_tutorial_arrow_thpng(): ThreeTexture {
        return this.resource<ThreeTexture>("assets/game/tutorial/arrow.thpng");
    }
    public get assets_game_ui_ui_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/game/ui/ui_1x.atlas.json");
    }
    public get assets_game_ui_timer_bar_fill_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["timer_bar/fill.png"];
    }
    public get assets_game_ui_timer_bar_substrate_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["timer_bar/substrate.png"];
    }
    public get assets_game_ui_timer_substrate_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["timer_substrate.png"];
    }
    public get assets_game_ui_health_bar_base_background_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["health_bar/base_background.png"];
    }
    public get assets_game_ui_health_bar_bar_progress_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["health_bar/bar_progress.png"];
    }
    public get assets_game_ui_pause_button_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["pause_button.png"];
    }
    public get assets_game_ui_health_bar_health_icon_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["health_bar/health_icon.png"];
    }
    public get assets_game_ui_health_bar_fly_health_icon_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["health_bar/fly_health_icon.png"];
    }
    public get assets_game_ui_timer_bar_tractor_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["timer_bar/tractor.png"];
    }
    public get assets_game_ui_timer_bar_house_png(): Texture {
        return this.assets_game_ui_ui_1x_atlas_json.textures["timer_bar/house.png"];
    }
    public get assets_game_ui_ui_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/game/ui/ui_1x.atlas.png");
    }
}

